export const ORGANIZATION_ID = 'selected_org_id';
